// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__OkNKC","footer":"ModalInfo_footer__2669Z"};